import { useSelector } from 'react-redux'
import { RootState } from 'types/state'

export const BotTyping = () => {
  const botMsgBackgroundColor = 'var(--primary-100)'
  const botMsgColor = '#f3f4f6'
  const botTyping = useSelector((state: RootState) => state.messageState.botTyping)

  return (
    <>
      {botTyping ? (
        <div className="tw-flex tw-space-x-1">
          <div className={`tw-flex tw-w-5 tw-items-end`}>
            <img
              className={`tw-h-5 tw-w-5 tw-rounded-none tw-text-primary-500 tw-text-white`}
              src={'icon-bot.svg'}
              alt={'icon bot'}
            />
          </div>
          <div
            className={`tw-flex tw-w-fit tw-space-x-2 tw-self-start tw-whitespace-pre-line tw-break-words tw-rounded-none tw-px-5 tw-py-3 tw-text-sm tw-text-white`}
            style={{ backgroundColor: botMsgBackgroundColor }}
          >
            <div
              className="tw-animation-delay-32 tw-h-2 tw-w-2 tw-animate-bounce tw-rounded-none tw-bg-primary-100 tw-p-1"
              style={{ backgroundColor: botMsgColor }}
            />
            <div
              className="tw-animation-delay-16 tw-h-2 tw-w-2 tw-animate-bounce tw-rounded-none tw-bg-primary-100 tw-p-1"
              style={{ backgroundColor: botMsgColor }}
            />
            <div
              className="tw-h-2 tw-w-2 tw-animate-bounce tw-rounded-none tw-bg-primary-100 tw-p-1"
              style={{ backgroundColor: botMsgColor }}
            />
          </div>
        </div>
      ) : null}
    </>
  )
}
